import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useRefreshRelatedData } from '@/hooks/useRefreshRelatedData';
import { showApiErrorToast } from '@/utils/errors';
import { createInstitute } from '../api/institutes.api';
import type { CreateInstitutePayload } from '../types/institute.types';

export function useCreateInstitute(onSuccess?: () => void) {
  const refreshRelatedData = useRefreshRelatedData();

  return useMutation({
    mutationFn: (payload: CreateInstitutePayload) => createInstitute(payload),
    onSuccess: () => {
      void refreshRelatedData('institute');
      toast.success('Institute created successfully');
      onSuccess?.();
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to create institute');
    },
  });
}
